export default __webpack_public_path__ + "static/media/room.8f6f0d9f.png";